import React, { createContext, useContext } from "react";

// Define the shape of the context value
export interface EditorContextValue {
  readOnly: boolean;
  isFullscreen?: boolean;
  toggleFullscreen?: () => void;
  // Add more properties here in the future
}

// Create the context with a default value
const EditorContext = createContext<EditorContextValue>({
  readOnly: false,
  isFullscreen: false,
  toggleFullscreen: () => {},
});

// Create a provider component
export const EditorContextProvider: React.FC<{
  children: React.ReactNode;
  value: EditorContextValue;
}> = ({ children, value }) => {
  return (
    <EditorContext.Provider value={value}>{children}</EditorContext.Provider>
  );
};

// Create a hook to use the context
export const useEditorContext = () => {
  return useContext(EditorContext);
};
